import React from 'react';
import InputText from '../../Atoms/InputText';
import Button from '../../Atoms/Button';

function FormMail() {
  return (
    <div className="flex @container">
      <div className="shrink grow">
        <InputText label="E-mailadres" className="-mr-4" />
      </div>
      <div className="relative z-10 shrink-0 basis-32 @lg:basis-36">
        <Button
          shadow
          text="Mail"
          fluid
          color="secondary"
          className="!h-[48px] md:!h-[52px]"
        />
      </div>
    </div>
  );
}

export default FormMail;
